import { ButtonProps } from '@chakra-ui/react';
import { useI18nLn } from '~/hooks/store';
import { useGachaStatus } from '~/hooks/useGachaStatus';
import { GachaDetail } from '../../../types/resources/gachaDetail';
import { WebrollButton } from './WebrollButton';

type Props = {
  gachaDetail: GachaDetail;
} & ButtonProps;

export const GachaSalesStatusDisplayButton: React.FC<Props> = (
  props: Props
) => {
  const { gachaDetail, ...buttonProps } = props;
  const { t } = useI18nLn();
  const gachaUnPlayableStatusText = useGachaStatus(gachaDetail);

  return (
    <WebrollButton
      {...buttonProps}
      disabled={!!gachaUnPlayableStatusText.statusText}
    >
      {gachaUnPlayableStatusText.statusText ||
        props.children ||
        t('pages.gacha.play.view_play_buttons')}
    </WebrollButton>
  );
};
